/**
 * Gated validation recorder — no-op unless localStorage.__kss_validation === '1'.
 */
export function recordValidation(page, component, key, value, meta = {}) {
  try {
    if (typeof localStorage === 'undefined') return
    if (localStorage.getItem('__kss_validation') !== '1') return
    if (!window.__KSS_VALIDATION) window.__KSS_VALIDATION = { records: [] }
    window.__KSS_VALIDATION.records.push({
      page,
      component,
      key: String(key),
      value,
      meta: Object.keys(meta).length ? meta : undefined,
      ts: Date.now(),
    })
  } catch {
    /* no-op */
  }
}

// Resolve the validation "page" from the active route so shared builders
// (e.g. buildTree, used by Pricing Actions / Bubble Plots / Pricing Rules)
// tag records with the page actually being viewed instead of a hard-coded one.
export function currentPage(fallback = 'dashboard') {
  if (typeof window === 'undefined') return fallback
  const p = window.location?.pathname?.replace(/^\//, '').split('?')[0]
  return p || fallback
}

export function recordMetricValues(metricId, currentVal, changes = [], ytdValue = null) {
  const page = currentPage()
  recordValidation(page, 'metric', `${metricId}:currentVal`, currentVal)
  for (const c of changes) {
    if (c?.value != null) recordValidation(page, 'metric_delta', `${metricId}:${c.label}`, c.value)
  }
  if (ytdValue != null) recordValidation(page, 'metric', `${metricId}:ytd`, ytdValue)
}

export function recordValidationBatch(page, component, rows, keyFn, fields) {
  if (!rows?.length) return
  for (const row of rows) {
    const base = keyFn(row)
    for (const field of fields) {
      if (row[field] != null) {
        recordValidation(page, component, `${base}:${field}`, row[field])
      }
    }
  }
}

/** Export captured validation records (dev tooling for DV-TF-06). */
export function exportValidationRecords() {
  if (typeof window === 'undefined') return { records: [] }
  return { records: [...(window.__KSS_VALIDATION?.records ?? [])] }
}

export function clearValidationRecords() {
  if (typeof window === 'undefined') return
  if (window.__KSS_VALIDATION) window.__KSS_VALIDATION.records = []
}
